// Note: These string values are hard-coded as i18n keys, and are also used for search string keywords.
export const submitterType = {
  USER: 'submitter',
  GROUP: 'group',
};

export const SUBMITTER_TYPES = Object.values(submitterType);
